query RevitValues{
    revitValues {
        id

        parameterID
        bimClassID

        value
        revitValue
    }
}
